import { render, staticRenderFns } from "./ContractOrder.vue?vue&type=template&id=2d4c60e1&scoped=true&"
import script from "./ContractOrder.vue?vue&type=script&lang=js&"
export * from "./ContractOrder.vue?vue&type=script&lang=js&"
import style0 from "./ContractOrder.vue?vue&type=style&index=0&id=2d4c60e1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4c60e1",
  null
  
)

export default component.exports